export const light = {
  title: 'light',
  colors: {
    c01: '#ffffff',
    c02: '#7f47dd',
    c03: '#015D7F',
    c04: '#020e42',
    c05: '#FFFFFF',
    c06: '#000000',
    c07: '#FBFBFB',
    c08: '#d3d3d3',
    c09: '#0000FF',
    c10: '#FFFF00',
    c11: '#DC3545',
    c12: 'rgba(0, 0, 0, 0.2)',
    c13: '#FF0000',
    c14: '#5E5187',
    c15: '#3A4365',
    c16: '#F1F1F1',
    c17: '#FFFFFF',
    c18: '#3FC248',
    c19: '#2196f3',
    c20: '#020e42',
    bgLogin: '/assets/fundo.png',
    lunch: '/assets/lunch.png',
    bgStop: '/assets/stop-sign-svgrepo-com.svg',
    bgAccount: '/assets/2313903-ai-bg.png',
    bgIllust: '/assets/2313903-ai.png'
  }
};
